module.exports = __webpack_public_path__ + "img/statistics.c23a1ed2.svg";